module.exports = __webpack_public_path__ + "static/img/cop_sch_logo11.b2c19910.png";